package org.zq.astrock_ai.ui.research.gushi.data

import org.zq.astrock_ai.api.dto.QuantScanItemDto

/** 相对上次扫描的信号变化标签。 */
enum class ScanChangeKind(val label: String) {
    NEW_BUY("新买"),
    NEW_SELL("新卖"),
    TO_BUY("转买"),
    TO_SELL("转卖"),
}

fun diffScanChanges(
    previous: Map<String, String>,
    items: List<QuantScanItemDto>,
): Map<String, ScanChangeKind> {
    if (previous.isEmpty()) return emptyMap()
    val out = linkedMapOf<String, ScanChangeKind>()
    for (item in items) {
        val prev = previous[item.code]?.uppercase()
        val cur = item.signal.uppercase()
        when {
            prev == null && cur == "BUY" -> out[item.code] = ScanChangeKind.NEW_BUY
            prev == null && cur == "SELL" -> out[item.code] = ScanChangeKind.NEW_SELL
            prev != null && prev != cur && cur == "BUY" -> out[item.code] = ScanChangeKind.TO_BUY
            prev != null && prev != cur && cur == "SELL" -> out[item.code] = ScanChangeKind.TO_SELL
        }
    }
    return out
}

fun Map<String, QuantScanItemDto>.toSignalMap(): Map<String, String> =
    mapValues { it.value.signal.uppercase() }
